(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-product"]) return;
  try {
    
  const auditWishlistRoot = document.querySelector('main');
  if (auditWishlistRoot) {
    const syncWishlistButtons = () => {
      auditWishlistRoot.querySelectorAll('.wishlist-engine').forEach(control => {
        const label = control.querySelector('.wishlist-text');
        if (!label) return;
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        const name = label.textContent.trim();
        if (name && control.getAttribute('aria-label') !== name) {
          control.setAttribute('aria-label', name);
        }
      });
    };
    auditWishlistRoot.addEventListener('keydown', event => {
      const control = event.target.closest('.wishlist-engine[role="button"]');
      if (!control || event.target !== control || event.repeat) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        const button = control.querySelector('.wishlist-engine-button');
        if (button) button.click();
      }
    });
    syncWishlistButtons();
    new MutationObserver(syncWishlistButtons).observe(auditWishlistRoot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label']
    });
  }

  } catch(e) { console.error(e); }
})();
})();
